import apiClient from './apiClient';

export type FlagKey =
  | 'PAID_PLANS_ENABLED'
  | 'BOTS_AND_MESSAGING_ENABLED'
  | 'WHATSAPP_BOT_ENABLED'
  | 'TELEGRAM_BOT_ENABLED'
  | 'AI_SCHEDULE_GENERATOR_ENABLED'
  | 'AI_OCR_ENABLED'
  | 'AI_OCR_RX_ENABLED'
  | 'AI_OCR_ATTACHMENTS_ENABLED'
  | 'AI_OCR_LAB_ENABLED'
  | 'AI_OCR_IMAGING_ENABLED'
  | 'AI_OCR_INBOX_ENABLED'
  | 'AI_OCR_RECORD_ENABLED'
  | 'AI_TIMELINE_ENABLED'
  // One-page patient chart: safety block on top, tabs become a timeline
  // filter. Presentation only; off restores the tabbed chart exactly.
  | 'SIMPLE_CHART_ENABLED'
  | 'NAV_DIET_ENABLED'
  // Doctor home as a single queue column, read from the server-backed
  // walk-in queue only. Off restores the existing multi-section home.
  | 'DOCTOR_QUEUE_HOME_ENABLED'
  | 'PATIENT_PORTAL_ENABLED'
  | 'PATIENT_PORTAL_ENCOUNTERS_VISIBLE'
  // Dual-cadence live transcription: fast undiarized ~10s preview text
  // alongside the canonical 30s diarized partials. Costs extra STT GPU
  // per consult — enable per-tenant once capacity is verified.
  | 'SCRIBE_FAST_PARTIALS'
  // Copilot deep research (async cited reports). Backend default ON;
  // pre-auth fallback off like the other AI flags.
  | 'AI_DEEP_RESEARCH_ENABLED';

export type FlagMap = Record<string, boolean>;

interface Envelope<T> {
  success?: boolean;
  data?: T;
}

const unwrap = <T>(payload: Envelope<T> | T): T => {
  if (
    payload &&
    typeof payload === 'object' &&
    'data' in (payload as object)
  ) {
    return (payload as Envelope<T>).data as T;
  }
  return payload as T;
};

export const platformFlagsApi = {
  getMine: async (): Promise<FlagMap> => {
    const { data } = await apiClient.get('/me/platform-flags');
    return unwrap(data);
  },
};
